/**
 * Base symbols the INX ticker returns that the real-world assets grid owns.
 *
 * The feed lists them alongside the cryptocurrencies, so without this the same
 * two assets render twice on the page — once as a rail tile and once as an RWA
 * card. The rail filters them out; the RWA cards read their price and 24h
 * change from the same feed, through the same formatters.
 *
 * Typed as `readonly string[]` rather than a literal tuple so `.includes` takes
 * any symbol the feed produces.
 */
export const RWA_TICKER_SYMBOLS: readonly string[] = ['NOTE', 'ANIMOCA'];
/** exclude security tokens as well */
export const SECURITY_TOKENS_TO_EXCLUDE: readonly string[] = [
  'FURA',
  'HAG',
  'TRUCPAL',
];
